import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";
import { param } from "~/utils/url_helper";

export const useWorkloadTasks = (params, config) => {
  return useQuery({
    ...config,
    queryKey: ["workload-tasks", params],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/workload/tasks?${param(params)}`,
        signal,
      }),
  });
};
